/* eslint-disable react/display-name */
// react
import React, { useState } from 'react'
import { Button, BUTTON_THEME } from '@st-operations/uikit/src/v2/index.js'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'

// components
import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'
import CreateCustomTaxonomiesModal from '_components/create-custom-taxonomies-modal'
import { deleteCustomTaxonomies } from '_services/data-explorer'
import MediaMeasurementCampaignsStatusBadge from '_components/media-measurement-campaign-status-badge'

// Styles
import './styles.scss'

const CustomTaxonomies = () => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div id="custom-taxonomies-page" className="custom-taxonomies">
      <Header title="Custom Taxonomies">
        <Button
          theme={BUTTON_THEME.PRIMARY}
          onClick={() => setModalOpen((modalOpen) => setModalOpen(!modalOpen))}
        >
          Create New Taxonomy
        </Button>
      </Header>
      <ListView
        columns={[
          {
            name: 'Taxonomy Name',
            link: '/custom-taxonomies/:_id',
            key: 'name',
            styles: {
              maxWidth: '200px',
              textAlign: 'left',
            },
          },
          {
            name: 'Status',
            key: 'status',
            styles: {
              maxWidth: '200px',
              textAlign: 'left',
            },
            render: (item) => <MediaMeasurementCampaignsStatusBadge status={item.status} />,
          },
          {
            name: 'Created By',
            key: 'created_by.email',
            styles: {
              maxWidth: '200px',
              textAlign: 'left',
            },
          },
          {
            name: 'Created At',
            key: 'created_at',
            format: 'date',
            styles: {
              maxWidth: '200px',
              textAlign: 'left',
            },
          },
          {
            name: 'Updated By',
            key: 'updated_by.email',
            styles: {
              maxWidth: '200px',
              textAlign: 'left',
            },
          },
          {
            name: 'Updated At',
            key: 'updated_at',
            format: 'date',
            styles: {
              maxWidth: '200px',
              textAlign: 'left',
            },
            sortable: true,
          },
        ]}
        entities="custom-taxonomies"
        searchable
        extractItems={(resp) => resp.items}
        extractCount={(resp) => resp.items.length}
        sort_key={'updated_at'}
        sort_dir={-1}
        actions={[
          // TODO: Add BE actions
          {
            name: 'Delete',
            onClick: (ids) => {
              const promises = [...ids].map((id) => deleteCustomTaxonomies(id))
              Promise.all(promises)
            },
            icon: { icon: 'trashcan', type: 'outline' },
          },
        ]}
        filters={[
          {
            name: 'status',
            label: 'Status',
            options: ['draft', 'submitted', 'processed', 'invalid'],
            all: true,
          },
        ]}
      />
      <Dialog open={modalOpen} close={() => setModalOpen(false)}>
        <CreateCustomTaxonomiesModal onClose={() => setModalOpen(false)} />
      </Dialog>
    </div>
  )
}

// export
export default CustomTaxonomies
